import { render, staticRenderFns } from "./Submenu6.vue?vue&type=template&id=6400cc92&scoped=true&"
import script from "./Submenu6.vue?vue&type=script&lang=js&"
export * from "./Submenu6.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6400cc92",
  null
  
)

export default component.exports